import React, { useMemo } from 'react';
import {
  Pencil,
  ToggleLeft,
  ToggleRight,
  Trash2,
} from 'lucide-react';
import GroupedRowActionSheet, { ICON_PROPS } from '../ui/GroupedRowActionSheet';
import useDemoActionGate from '../hooks/useDemoActionGate';
import DemoLockedDialog from '../ui/DemoLockedDialog';

/**
 * Per-question row actions — config wrapper around GroupedRowActionSheet.
 * Question-level enable/disable/edit/delete live here; page Actions holds assessment-wide tools only.
 */
export default function QuestionRowActionsMenu({
  row,
  onEdit,
  onToggleStatus,
  onDelete,
}) {
  const { lockProps, lockedDialogOpen, setLockedDialogOpen } = useDemoActionGate();
  const isEnabled = row.active === 1;

  const groupItems = useMemo(() => [
    {
      key: 'toggle',
      icon: isEnabled ? <ToggleLeft {...ICON_PROPS} /> : <ToggleRight {...ICON_PROPS} />,
      label: isEnabled ? 'Disable question' : 'Enable question',
      ...lockProps('action.assessment.question.disable'),
    },
  ], [isEnabled, lockProps]);

  const handleAction = (key) => {
    if (key === 'edit') onEdit(row);
    else if (key === 'toggle') onToggleStatus(row);
    else if (key === 'delete') onDelete(row);
  };

  return (
    <>
      <GroupedRowActionSheet
        entityLabel="Question"
        title={row.question}
        menuAriaLabel="Question actions"
        layoutKey={`${row.questionId}-${isEnabled}`}
        primary={{
          key: 'edit',
          icon: <Pencil {...ICON_PROPS} />,
          label: 'Edit question',
          ...lockProps('action.assessment.question.edit'),
        }}
        groupLabel="For this question"
        groupItems={groupItems}
        dangerItem={{
          key: 'delete',
          icon: <Trash2 {...ICON_PROPS} />,
          label: 'Delete',
          ...lockProps('action.assessment.question.delete'),
        }}
        onAction={handleAction}
      />
      <DemoLockedDialog open={lockedDialogOpen} onClose={() => setLockedDialogOpen(false)} />
    </>
  );
}
